/* eslint-disable jsx-a11y/click-events-have-key-events */
import Trans from 'next-translate/Trans'
import { STATUS_CANCELLED } from 'tennders-stracture/libs/constants'
import GHref from 'tennders-market/common/components/element/GHref'
import { TransactionType } from 'tennders-transactions/types/TransactionType'
import usePopupStore from 'tennders-common/stores/usePopupStore'
import IconSendBid from '../../../../../../icons/icon-send-bid.svg'

type Props = {
    transaction: TransactionType
    color?: string
}

const RowShareOfferAction = ({ transaction, color }: Props) => {
  const [show] = usePopupStore((state: Record<string, any>) => [state.show])
  const setCheckOffer = (transaction) => show('checkOffer', { transaction })

  if (transaction?.status?.label === STATUS_CANCELLED || !(transaction?.pickupRoute || transaction?.pickupRoutes)) {
    return null
  }

  return (
    <GHref
      onClick={() => setCheckOffer(transaction)}
      className="d-flex col cell-icon flex-center"
    >
      <IconSendBid />
      <div className="icon-label" style={{ color }}><Trans i18nKey="tableRow:sendBid" /></div>
    </GHref>
  )
}

export default RowShareOfferAction
